import React, { useState } from 'react';
import SectionTitle from '../../yourProperties/Title';
import useTranslate from '../../../../customHooks/useTranslate';
import {
    useContractDetail,
    useContractDetailData,
} from '../../../contextsProperty/ContextContractDetail';
import Menu from '../../components/Menu';
import Grid from '../../../../muiComponents/Grid';
import {
    doubleLG_ColumnGrid,
    gridSpacing20,
    gridSpacing30,
} from '../../../../utils/commonVariables/grid';
import Card from '../../../../muiComponents/Card';
import GridChild from '../../../../muiComponents/GridChild';
import Title from '../../../components/Title';
import DotIcon from '../../../components/DotIcon';
import Icon from '../../../../muiComponents/Icon';
import Tooltip from '../../../../muiComponents/Tooltip';
import { Alert } from '@mui/material';
import Button from '../../../../muiComponents/Button';
import {
    ContractDetailPanelNames,
    RATE_SCOPE_MODEL_KEY_ICON,
} from '../../../../types/contracts/contractTypes';
import RoomPanel from './panels/RoomPanel';
import { RATE_SCOPE_MODEL_KEY_ICON_COLOR } from '../../../../utils/contractUtils/contractUtils';
import DeletePopUp from './DeletePopUp';
import { useNotification } from '../../../../contexts/NotificationsContext';
import { FeedbackMessages } from '../../../../utils/commonVariables/messages';
import LoadingSection from './LoadingSection';
import useUserProfile from '../../../../customHooks/useUserProfile';

const Rooms = () => {
    const translate = useTranslate();
    const {
        isMainInfoEmpty,
        isBlockedContract,
        handleOpenRoomPanel,
        openedPanel,
        handleOpenPanel,
        handleSaveRoom,
        handleLoadingView,
        isLoadingView,
    } = useContractDetail();
    const { rooms, rateScopeModel, rateScopeModelKey } =
        useContractDetailData();
    const { setErrorMessage, setSuccessMessage } = useNotification();
    const { readOnlyUser } = useUserProfile();

    const [deletePopUpVisible, setDeletePopUpVisible] = useState('');

    const handleCloseRoomPanel = () => {
        handleOpenPanel(null);
    };

    return (
        <>
            {deletePopUpVisible && !readOnlyUser && (
                <DeletePopUp
                    open={!!deletePopUpVisible}
                    onSave={async () => {
                        const deletedRoom = rooms.find(
                            room => room.id === deletePopUpVisible
                        );
                        if (!deletedRoom) return;
                        try {
                            handleLoadingView(true);
                            await handleSaveRoom({
                                ...deletedRoom,
                                Deleted: true,
                            });
                            setSuccessMessage(
                                FeedbackMessages.COMMON_SUCCESS_DELETE
                            );
                        } catch (error) {
                            setErrorMessage(FeedbackMessages.COMMON_ERROR);
                        } finally {
                            handleLoadingView(false);
                            setDeletePopUpVisible('');
                        }
                    }}
                    onCancel={() => {
                        setDeletePopUpVisible('');
                    }}
                ></DeletePopUp>
            )}
            {openedPanel === ContractDetailPanelNames.ROOMS && (
                <RoomPanel
                    open={openedPanel === ContractDetailPanelNames.ROOMS}
                    onClose={handleCloseRoomPanel}
                />
            )}
            <section className='contract-detail__section'>
                <div className='flex flex-between flex-align-center'>
                    <SectionTitle text={translate('rooms')} />
                    {!isMainInfoEmpty && (
                        <Menu
                            menuItems={[
                                {
                                    text: 'add',
                                    icon: 'Add',
                                    disabled: isBlockedContract || readOnlyUser,
                                    onClick: () => {
                                        handleOpenRoomPanel({
                                            __isAdded: true,
                                            __isChanged: true,
                                        });
                                    },
                                },
                            ]}
                        />
                    )}
                </div>
                {isLoadingView ? (
                    <LoadingSection />
                ) : rooms.length ? (
                    <Grid
                        style={{ width: 'auto' }}
                        columnSpacing={gridSpacing30}
                        rowSpacing={gridSpacing20}
                    >
                        {rooms?.map(room => {
                            const targetRateScopeModelKey =
                                room.rateScopeModelKey
                                    ? room.rateScopeModelKey
                                    : rateScopeModelKey;
                            return (
                                <GridChild
                                    key={room.id}
                                    gridProps={doubleLG_ColumnGrid}
                                >
                                    <Card
                                        id={room.id}
                                        style={{ padding: '20px 20px' }}
                                    >
                                        <div className='flex flex-between'>
                                            <Title key={room.id}>
                                                {room.name}
                                            </Title>
                                            <div className='flex flex-align-center gap-20'>
                                                <div className='flex flex-align-center gap-5'>
                                                    <DotIcon
                                                        truthy={room.enabled}
                                                        falsy={!room.enabled}
                                                    />
                                                    <small>
                                                        {room.enabled
                                                            ? translate(
                                                                  'enabled'
                                                              )
                                                            : translate(
                                                                  'disabled'
                                                              )}
                                                    </small>
                                                </div>
                                                <Menu
                                                    menuItems={[
                                                        {
                                                            text: readOnlyUser
                                                                ? 'view'
                                                                : 'edit',
                                                            icon: readOnlyUser
                                                                ? 'Visibility'
                                                                : 'Edit',
                                                            onClick: () => {
                                                                handleOpenRoomPanel(
                                                                    {
                                                                        ...room,
                                                                        __isChanged:
                                                                            true,
                                                                    }
                                                                );
                                                            },
                                                        },
                                                        {
                                                            text: room.enabled
                                                                ? 'disabled'
                                                                : 'enabled',
                                                            icon: room.enabled
                                                                ? 'NotInterested'
                                                                : 'Circle',
                                                            disabled:
                                                                isBlockedContract ||
                                                                readOnlyUser,
                                                            onClick:
                                                                async () => {
                                                                    try {
                                                                        handleLoadingView(
                                                                            true
                                                                        );
                                                                        await handleSaveRoom(
                                                                            {
                                                                                ...room,
                                                                                enabled:
                                                                                    !room.enabled,
                                                                                __isChanged:
                                                                                    true,
                                                                            }
                                                                        );
                                                                        setSuccessMessage(
                                                                            FeedbackMessages.COMMON_SUCCESS_DELETE
                                                                        );
                                                                    } catch (error) {
                                                                        setErrorMessage(
                                                                            FeedbackMessages.COMMON_ERROR
                                                                        );
                                                                    } finally {
                                                                        handleLoadingView(
                                                                            false
                                                                        );
                                                                        setDeletePopUpVisible(
                                                                            ''
                                                                        );
                                                                    }
                                                                },
                                                        },
                                                        {
                                                            text: 'delete',
                                                            icon: 'Delete',
                                                            disabled:
                                                                isBlockedContract ||
                                                                readOnlyUser,
                                                            onClick: () => {
                                                                setDeletePopUpVisible(
                                                                    room.id
                                                                );
                                                            },
                                                        },
                                                    ]}
                                                />
                                            </div>
                                        </div>
                                        <Grid
                                            columnSpacing={gridSpacing30}
                                            rowSpacing={gridSpacing20}
                                        >
                                            <GridChild
                                                gridProps={doubleLG_ColumnGrid}
                                            >
                                                <div className='flex flex-align-center gap-10'>
                                                    <div className='flex flex-align-center gap-10 text-overflow-ellipsis'>
                                                        <Icon
                                                            iconName='Groups'
                                                            className='text-seconday-700'
                                                        />
                                                        <Tooltip titleText='occupancy'>
                                                            <p className='text-overflow-ellipsis'>
                                                                {translate(
                                                                    'standard'
                                                                )}{' '}
                                                                {
                                                                    room.standardOccupancy
                                                                }
                                                                {' - '}
                                                                {translate(
                                                                    'max'
                                                                )}{' '}
                                                                {
                                                                    room.maxOccupancy
                                                                }
                                                            </p>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                            </GridChild>
                                            <GridChild
                                                gridProps={doubleLG_ColumnGrid}
                                            >
                                                <div className='flex flex-align-center gap-10'>
                                                    <Icon
                                                        iconName={
                                                            RATE_SCOPE_MODEL_KEY_ICON[
                                                                targetRateScopeModelKey as keyof typeof RATE_SCOPE_MODEL_KEY_ICON
                                                            ]
                                                        }
                                                        style={{
                                                            color: RATE_SCOPE_MODEL_KEY_ICON_COLOR[
                                                                targetRateScopeModelKey as keyof typeof RATE_SCOPE_MODEL_KEY_ICON_COLOR
                                                            ],
                                                        }}
                                                    />
                                                    {/*  el rate scope model de la habtación sino la general del contrato */}
                                                    {room.rateScopeModel ? (
                                                        <Tooltip titleText='rate_scope_model'>
                                                            <p className='text-overflow-ellipsis'>
                                                                {
                                                                    room.rateScopeModel
                                                                }
                                                            </p>
                                                        </Tooltip>
                                                    ) : (
                                                        <div className='flex flex-between gap-20 flex-align-center'>
                                                            <Tooltip titleText='rate_scope_model'>
                                                                <p className='text-overflow-ellipsis'>
                                                                    {
                                                                        rateScopeModel
                                                                    }
                                                                </p>
                                                            </Tooltip>
                                                            <Tooltip titleText='general_rate_scope_applied'>
                                                                <div>
                                                                    <Icon
                                                                        iconName={
                                                                            'InfoOutlined'
                                                                        }
                                                                        sx={{
                                                                            color: '#ffc107',
                                                                            width: '16px',
                                                                            height: '16px',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                    />
                                                                </div>
                                                            </Tooltip>
                                                        </div>
                                                    )}
                                                </div>
                                            </GridChild>
                                        </Grid>
                                    </Card>
                                </GridChild>
                            );
                        })}
                    </Grid>
                ) : (
                    <Card
                        className='contract-card__empty flex-center width100perc'
                        style={{ minHeight: '150px', padding: '10px 20px' }}
                    >
                        {isMainInfoEmpty ? (
                            <Alert severity='info' sx={{ width: '100%' }}>
                                {translate('add_main_info_first')}
                            </Alert>
                        ) : (
                            <Button
                                startIcon='Add'
                                disabled={readOnlyUser}
                                onClick={() => {
                                    handleOpenRoomPanel({
                                        __isAdded: true,
                                        __isChanged: true,
                                    });
                                }}
                            >
                                {translate('add')}
                            </Button>
                        )}
                    </Card>
                )}
            </section>
        </>
    );
};

export default Rooms;
